import {
  RESET_PAY_FOR_AD_STATE,
  SET_CHECKOUT_ERROR,
  SET_LOADING_CHECKOUT_SESSION,
  SET_LOADING_INVOICE_DATA,
  SET_PAYMENT_METHODS,
  SET_PAYMENT_SESSION,
  SET_PROMO_CODE,
  SET_PROMO_CODE_ERROR,
  SET_RENEWAL_ERROR,
  SET_SELECTED_PACKAGE_ID,
  SET_SELECTED_PAYMENT_METHOD,
} from "../../actions/pay-for-ad";

const initialState = {
  selectedPackageId: undefined,
  selectedPaymentMethod: {},
  recurringPayment: undefined,
  renewalError: false,
  checkoutError: false,
  paymentSession: {},
  promoCode: undefined,
  promoCodeError: "",
  loadingInvoiceData: false,
  loadingCheckoutSession: false,
  paymentMethods: [],
};

const payForAdReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_SELECTED_PACKAGE_ID:
      return { ...state, selectedPackageId: payload };
    case SET_SELECTED_PAYMENT_METHOD:
      return { ...state, selectedPaymentMethod: payload };
    case SET_RENEWAL_ERROR:
      return { ...state, renewalError: payload };
    case SET_CHECKOUT_ERROR:
      return { ...state, checkoutError: payload };
    case SET_PAYMENT_SESSION:
      return { ...state, paymentSession: payload };
    case SET_PROMO_CODE:
      return { ...state, promoCode: payload };
    case SET_PROMO_CODE_ERROR:
      return { ...state, promoCodeError: payload };
    case SET_LOADING_INVOICE_DATA:
      return { ...state, loadingInvoiceData: payload };
    case SET_LOADING_CHECKOUT_SESSION:
      return { ...state, loadingCheckoutSession: payload };
    case SET_PAYMENT_METHODS:
      return { ...state, paymentMethods: payload };
    case RESET_PAY_FOR_AD_STATE:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default payForAdReducer;
